import React from 'react';

/**
 * `hidden`: payload `hideHeader` — Sessionboard Site pages already show the
 * event name in the Site's own header.
 */
export default function Header({ eventName = 'Event Name', primaryColor, hidden = false }) {
  if (hidden) return null;
  return (
    <header className="widget-header" style={primaryColor ? { backgroundColor: primaryColor } : {}}>
      <h1 className="widget-header__title">{eventName}</h1>
    </header>
  );
}
